<app-slide-in-right-modal
  modalTitle="Referred Users"
  iconImageSrc="assets/images/svgs/document--outline.svg"
  [slideOpen]="true"
  [showBackLink]="false"
  returnPath="/admin/referrals"
>
  <div class="page__container flex flex-col pb-8">
    <!-- CARDS -->
    <div class="mt-[0.94rem] grid gap-5">
      <div
        class="rounded-lg border border-solid border-mango-gray200 bg-mango-paleBlue p-[38px]"
      >
        <!-- Total Users Referred -->
        <div>
          <p>Total Users Referred - {{ referralCode }}</p>
        </div>
        <div>
          <p class="text-2xl font-bold text-gray-900">{{ totalReferrals }}</p>
        </div>
      </div>
    </div>

    <!-- Filters -->
    <app-filters [filters]="filterStructure"></app-filters>

    <!-- table skeleton loader -->
    @if (isLoading) {
      <div class="mt-[0.94rem]">
        <app-table-skeleton-loader></app-table-skeleton-loader>
      </div>
    }

    <!-- Table -->
    <div
      *ngIf="!isLoading"
      class="mt-[0.94rem] rounded-lg border border-solid border-mango-gray200 bg-white"
    >
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div
            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
          >
            <table class="min-w-full leading-normal">
              <thead>
                <tr>
                  <th
                    class="flex border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold text-gray-600"
                  >
                    S/N
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M7.99998 3.33301V12.6663M7.99998 12.6663L12.6666 7.99967M7.99998 12.6663L3.33331 7.99967"
                        stroke="#667085"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </th>
                  <th
                    class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
                  >
                    Name
                  </th>
                  <th
                    class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
                  >
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (referee of referredUsers; track referee; let i = $index) {
                  <tr>
                    <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                      <p>{{ getRowIndex(i) }}</p>
                    </td>
                    <!-- Name -->
                    <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                      <p class="whitespace-no-wrap text-gray-900">
                        {{ referee.name }}
                      </p>
                    </td>
                    <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                      <p class="whitespace-no-wrap text-gray-900">
                        {{ referee.created_at | date: 'mediumDate' }}
                      </p>
                    </td>
                  </tr>

                  
                }

                <!-- Empty state -->
                <tr *ngIf="referredUsers.length === 0">
                  <td
                    colspan="2"
                    class="border-b border-gray-200 bg-white px-5 py-8 text-center text-gray-500"
                  >
                    <p>No referred users found</p>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination -->
            <app-table-navigator
              *ngIf="totalReferrals > 0"
              [total]="totalReferrals"
              (onNavigation)="navigate($event)"
            ></app-table-navigator>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-slide-in-right-modal>